"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
/** @jsxImportSource @emotion/react */
const react_1 = require("@emotion/react");
const react_2 = require("react");
const ZoneUtilities_1 = require("../../../data/utilities/ZoneUtilities");
const AssignmentsContext_1 = require("../../assignment/AssignmentsContext");
const highlight_1 = require("../../highlight");
const useActiveSpectrumZonesViewState_1 = require("../../hooks/useActiveSpectrumZonesViewState");
const scale_1 = require("../utilities/scale");
const Signal_1 = __importDefault(require("./Signal"));
const stylesOnHover = (0, react_1.css) `
  pointer-events: bounding-box;

  @-moz-document url-prefix("") {
    pointer-events: fill;
  }

  user-select: none;

  .delete-button {
    visibility: hidden;
  }
`;
const stylesHighlighted = (0, react_1.css) `
  pointer-events: bounding-box;

  @-moz-document url-prefix("") {
    pointer-events: fill;
  }

  .integral-area {
    fill: #ff6f0057;
  }

  .delete-button {
    visibility: visible;
    cursor: pointer;
  }
`;
function Zone({ zoneData }) {
    const { x, y, id, signals } = zoneData;
    const assignmentZone = (0, AssignmentsContext_1.useAssignment)(id);
    const { showZones } = (0, useActiveSpectrumZonesViewState_1.useActiveSpectrumZonesViewState)();
    const highlightZone = (0, highlight_1.useHighlight)([assignmentZone.id], {
        type: highlight_1.HighlightEventSource.ZONE,
        extra: { id: assignmentZone.id },
    });
    const scaleX = (0, scale_1.useScale2DX)();
    const scaleY = (0, scale_1.useScale2DY)();
    const { from: x1 = 0, to: x2 = 0 } = x;
    const { from: y1 = 0, to: y2 = 0 } = y;
    const [reduceOpacity, setReduceOpacity] = (0, react_2.useState)(false);
    (0, react_2.useEffect)(() => {
        setReduceOpacity(!(0, ZoneUtilities_1.checkZoneKind)(zoneData));
    }, [zoneData]);
    return ((0, jsx_runtime_1.jsxs)("g", { css: highlightZone.isActive || assignmentZone.isActive
            ? stylesHighlighted
            : stylesOnHover, onMouseEnter: () => {
            assignmentZone.show();
            highlightZone.show();
        }, onMouseLeave: () => {
            assignmentZone.hide();
            highlightZone.hide();
        }, children: [showZones && ((0, jsx_runtime_1.jsx)("g", { transform: `translate(${scaleX(x2)},${scaleY(y1)})`, children: (0, jsx_runtime_1.jsx)("rect", { x: "0", width: scaleX(x1) - scaleX(x2), height: scaleY(y2) - scaleY(y1), className: "integral-area", fill: "#0000000f", stroke: reduceOpacity ? '#343a40' : 'darkgreen', strokeWidth: reduceOpacity ? '0' : '1' }) })), signals.map((_signal, i) => ((0, jsx_runtime_1.jsx)(Signal_1.default, { signal: _signal }, `${id + i}`)))] }, id));
}
exports.default = Zone;
